export const detectScriptType = () => {
  const hasChromeRuntime = typeof chrome !== 'undefined' && chrome.runtime?.id
  const hasWindow = typeof window !== 'undefined' && !window.isPolyfill

  if (hasChromeRuntime && hasWindow) {
    if (window.location.pathname.includes('background')) return 'background'
    if (window.location.pathname.includes('contentscript')) return 'contentScript'
    if (
      window.location.pathname.includes('popup') ||
      window.location.pathname.includes('sidepanel') ||
      window.location.pathname.includes('home')
    )
      return 'popup'
    return 'contentScript'
  }
  if (hasChromeRuntime && !hasWindow) return 'background'
  if (!hasChromeRuntime && hasWindow) return 'inpage'
  throw new Error('Undetected script.')
}

export type ScriptType = ReturnType<typeof detectScriptType>
